import request_index from "../index";
import { getUsessionId } from '@/utils-khfw/usession.service.js';
async function request(params) {
  let uid = await getUsessionId();
  if (params.data) {
    params.data = {
      ...params.data,
      loginPlatformCode: sessionStorage.getItem("loginPlatformCode"),
      platformCode: sessionStorage.getItem("platformCode"),
      usessionid: uid,
    }
  }
  return request_index(params);
};
const educationApi = {
  /******************* 课程接口-区级 **********************************/
  // 区级-课程审核列表
  getEducationCourseWiteauditlist(data) {
    return request({
      url: `/assbe/course/education/witeauditlist`,
      method: "post",
      data,
    })
  },
  // 区级-课程管理列表
  getEducationCourseManagelist(data) {
    return request({
      url: `/assbe/course/education/managelist`,
      method: "post",
      data,
    })
  },
  // 区级-课程审核及下架-机构送审课程
  educationCourseOperate(data) {
    return request({
      url: `/assbe/course/education/operate`,
      method: "post",
      data,
    })
  },
  // 区级-课程审核及下架-学校送审课程
  educationCourseOperateOfSchool(data) {
    return request({
      url: `/assbe/course/school/submitaudit`,
      method: "post",
      data,
    })
  },
  // 区级-课程管理列表 
  getEducationCourseauditrecord(data) {
    return request({
      url: `/assbe/course/education/courseauditrecord`,
      method: "post",
      data,
    })
  },
  // 区级-课程撤销
  getEducationCourseUndo(data) {
    return request({
      url: `/assbe/course/education/undo`,
      method: "POST",
      data,
    })
  },
  // 区级-材料审核列表
  getEducationMaterialsAuditlist(data) {
    return request({
      url: `/assbe/materials/education/auditlist`,
      method: "post",
      data,
    })
  },
  // 区级-材料管理列表
  getEducationMaterialsMannagelist(data) {
    return request({
      url: `/assbe/materials/education/mannagelist`,
      method: "post",
      data,
    })
  },
  // 区级-试课审核列表
  getEducationCourseAttemptList(data) {
    return request({
      url: `/assbe/course/education/attemptList`,
      method: "post",
      data,
    })
  },
  // 区级-试课审核详情
  getEducationCourseAttemptdetail(id) {
    return request({
      url: `/assbe/course/education/attemptdetail?aid=${id}`,
      method: "get",
    })
  },
  // 区级-试课审核
  educationCourseAttemptaudit(data) {
    return request({
      url: `/assbe/course/education/attemptaudit`,
      method: "post",
      data,
    })
  },
  // 区级-引用/取消引用课程
  educationCourseQuote(data) {
    return request({
      url: `/assbe/course/education/quote`,
      method: "post",
      data,
    })
  },
  // 区级-材料审核
  educationMaterialsAudit(data) {
    return request({
      url: `/assbe/materials/education/audit`,
      method: "post",
      data,
    })
  },

  // 省市-课程列表
  getProviceCourseList(data) {
    return request({
      url: `/assbe/course/provice/list`,
      method: "post",
      data,
    })
  },
  // 省市-材料列表
  getProviceMaterialsList(data) {
    return request({
      url: `/assbe/materials/provice/list`,
      method: "post",
      data,
    })
  },
  // 查看课程引入记录
  getCourseOrgintroduce(data) {
    return request({
      url: '/assbe/course/school/orgintroduce',
      method: 'post',
      data,
    })
  },
  /******************* 课程接口-教育局 **********************************/
  // 教育局-查询类目信息
  getFiveSportQuery(data) {
    return request({
      url: `assbe/category/query`,
      method: "post",
      data,
    })
  },
  // 教育局-新增类目
  getFiveSportAdd(data) {
    return request({
      url: `assbe/category/add`,
      method: "post",
      data,
    })
  },
  // 教育局-编辑类目信息
  getFiveSportEdit(data) {
    return request({
      url: `assbe/category/update`,
      method: "post",
      data,
    })
  },
  // 教育局-删除类目信息
  getFiveSportDel(data) {
    return request({
      url: `assbe/category/delete `,
      method: "post",
      data,
    })
  },
  /**
   * 
   * 风险预警
   * 
   */
  // 评价预警
  getRiskwarningEducationEvaluate(data) {
    return request({
      url: `/assbe/riskwarning/education/evaluate`,
      method: "post",
      data,
    })
  },
  /**
   * 
   * 订单管理
   * 
   */
  // 查询订单列表(教育局)
  handleOrderList(data) {
    return request({
      url: '/assbe/order/authority/list',
      method: "POST",
      data,
    });
  },
  //查询退费单列表(教育局)
  handleRefundsList(data) {
    return request({
      url: '/assbe/order/authority/refunds',
      method: "POST",
      data,
    });
  },
}

export default educationApi;